import dynamic from "next/dynamic";
import React from "react";

import { AppContext } from "../../../../lib/appContext";
import { LandingContext } from "../../context/landing";
import { useSelectedFilters } from "../../context/selectedFilters/selectedState";
import { TopDestinationsProps } from "../../components/Content/TravelBrazil/TopDestinations";
import { useExternalURLRedirection } from "../../../../core/hooks";

const DefaultLayout = dynamic(() =>
  import(/* webpackChunkName: "DesktopResultsLayout" */ "./Layout/Default")
);
const MobileLayout = dynamic(() =>
  import(/* webpackChunkName: "MobileResultsLayout" */ "./Layout/Mobile")
);
const OfferResults = dynamic(() =>
  import(/* webpackChunkName: "OffersResultsLayout" */ "./Layout/Offers").then(mod => mod.Results)
);
const ProductResults = dynamic(() =>
  import(/* webpackChunkName: "ProductsResultsLayout" */ "./Layout/Products").then(
    mod => mod.Results
  )
);

export const Results: React.FC<Pick<TopDestinationsProps, "destinations">> = ({ destinations }) => {
  const { offersMode, offerId, formId } = React.useContext(LandingContext);
  const { businessUnitConfig, isMobile } = React.useContext(AppContext);
  const Layout = isMobile ? MobileLayout : DefaultLayout;
  const { featured, secondary } = useSelectedFilters();

  const hasSelectedFilters = [featured, secondary].some(f => Object.keys(f).length > 0);
  useExternalURLRedirection("newResultsPage", { formId }, {}, Boolean(formId));

  return offersMode ? (
    <OfferResults
      businessUnitConfig={businessUnitConfig}
      offerId={offerId}
      formId={formId}
      Layout={Layout}
    />
  ) : formId ? null : (
    <ProductResults
      Layout={Layout}
      businessCode={businessUnitConfig.businessCode}
      hasSelectedFilters={hasSelectedFilters}
      destinations={destinations}
    />
  );
};
